import { useGetIdentity, useTranslate } from "ra-core";

import { firstName } from "../../layout/desk/shellModel";
import { useHomeView } from "./homeView";
import { useHomeFormat } from "./useHomeFormat";
import { useHomeToday } from "./useHomeData";

const greetingPart = (hour: number) =>
  hour < 12 ? "morning" : hour < 19 ? "afternoon" : "evening";

/** «Hoy»: greeting, date and what needs attention (same counts as the inbox). */
const TodayTitle = () => {
  const translate = useTranslate();
  const format = useHomeFormat();
  const { identity } = useGetIdentity();
  const { counters, isPending } = useHomeToday();
  const name = firstName(identity?.fullName);
  const part = greetingPart(new Date().getHours());
  const summary = isPending
    ? null
    : counters.attention === 0
      ? translate("desk.home.summary.all_clear")
      : translate("desk.home.summary.attention", {
          smart_count: counters.attention,
        });
  return (
    <div className="min-w-0">
      <h1 className="desk-header__title">
        {name
          ? translate(`hub.greeting.${part}_named`, { name })
          : translate(`hub.greeting.${part}`)}
      </h1>
      <p className="desk-header__subtitle">
        {format.longDate(new Date())}
        {summary ? ` · ${summary}` : null}
        {!isPending && counters.overdue > 0 ? (
          <span className="desk-header__overdue">
            {", "}
            {translate("desk.home.summary.overdue", {
              smart_count: counters.overdue,
            })}
          </span>
        ) : null}
      </p>
    </div>
  );
};

const PulseTitle = () => {
  const translate = useTranslate();
  const format = useHomeFormat();
  return (
    <div className="min-w-0">
      <h1 className="desk-header__title">
        {translate("desk.home.pulse.title")}
      </h1>
      <p className="desk-header__subtitle">
        {format.monthYear(new Date())} · {translate("desk.home.pulse.subtitle")}
      </p>
    </div>
  );
};

/** Left side of the desktop header on the home page. */
export const HomeHeaderTitle = () => {
  const [view] = useHomeView();
  return view === "pulse" ? <PulseTitle /> : <TodayTitle />;
};
